import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { HttpClient } from '@/network/HttpClient';

export const ASYNC_AUTOCOMPLETE_QUERY_KEY = 'async_autocomplete';

export type AsyncAutocompleteQueryParams<TResponse, TItem> = {
  queryKey: string | readonly unknown[];
  fetchUrl: string;
  searchValue: string;
  transformResponse: (response: TResponse) => TItem[];
  filters?: Record<string, unknown>;
  enabled?: boolean;
};

export const useAsyncAutocompleteQuery = <TResponse, TItem>(
  params: AsyncAutocompleteQueryParams<TResponse, TItem>,
) => {
  const {
    queryKey,
    fetchUrl,
    searchValue,
    transformResponse,
    filters,
    enabled = true,
  } = params;

  const queryKeyArray = Array.isArray(queryKey) ? queryKey : [queryKey];

  return useQuery({
    queryKey: [
      ASYNC_AUTOCOMPLETE_QUERY_KEY,
      ...queryKeyArray,
      fetchUrl,
      searchValue,
      filters,
    ],
    queryFn: async () => {
      const response = await HttpClient.request<TResponse>({
        method: 'GET',
        url: fetchUrl,
        params: {
          page: 1,
          size_per_page: 10,
          sort_column: 'created_at',
          sort_direction: 'desc',
          search: {
            value: searchValue,
          },
          filters,
        },
      });

      if (!response) return [];

      return transformResponse(response);
    },
    enabled,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });
};
